import {
  HttpClient,
  provideHttpClient,
  withInterceptorsFromDi,
  HTTP_INTERCEPTORS,
} from "@angular/common/http";
import {
  ApplicationConfig,
  ErrorHandler,
  importProvidersFrom,
  provideZoneChangeDetection,
} from "@angular/core";
import { provideAnimations } from "@angular/platform-browser/animations";
import { provideRouter } from "@angular/router";
import { provideStore } from "@ngrx/store";
import { TranslateLoader, TranslateModule } from "@ngx-translate/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
// Optional progress bar integration (uncomment when package is installed)
// import { NgProgressHttpModule } from "ngx-progressbar/http";

import { provideLottieOptions } from "ngx-lottie";
import player from "lottie-web";

import { routes } from "./app.routes";
import { indexReducer } from "./store/index.reducer";
import { AppService } from "./services/app.service";
import { AuthInterceptor } from "./core/intercepters/auth.interceptor";
import { HttpErrorInterceptor } from "./core/intercepters/http-error.interceptor";
import { provideHotToastConfig } from "@ngxpert/hot-toast";
import { AppUpdateErrorHandler } from "./core/handlers/app-update-error.handler";
import { provideKtRteEditor } from "kt-rte-editor";

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, "./assets/i18n/", ".json");
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    { provide: ErrorHandler, useClass: AppUpdateErrorHandler },
    provideRouter(routes),
    provideLottieOptions({ player: () => player }),
    provideAnimations(),
    // Default XHR: `withFetch()` can omit `Authorization` on some `DELETE`+JSON calls; keep same pipeline as POST /company/all.
    provideHttpClient(withInterceptorsFromDi()),
    provideStore({ index: indexReducer }),
    provideHotToastConfig({
      position: 'top-right',
      stacking: 'vertical',
      visibleToasts: 1,
    }),
    AppService,
    // HttpError runs outer; Auth inner so 401 is handled (refresh + retry) before error toasts
    { provide: HTTP_INTERCEPTORS, useClass: HttpErrorInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    importProvidersFrom(
      TranslateModule.forRoot({
        defaultLanguage: "en",
        loader: {
          provide: TranslateLoader,
          useFactory: HttpLoaderFactory,
          deps: [HttpClient],
        },
      }),
      // Optional progress bar integration (enable when module is installed)
      // NgProgressHttpModule
    ),
    provideKtRteEditor(),
  ],
};
